import styled from 'styled-components/native';
import { IOtpInputBoxProps } from '@fkhplus/common/src/components/atoms/OTPInput';

export const OTPInput = styled.TextInput`
  padding: 6px 10px 6px 10px ;
  color: ${(props: any) =>props.theme.palette.neutral.greys400};
`;

export const Container = styled.View<{ styleProp: IOtpInputBoxProps }>`
border-width: 0.5px;
border-color: ${(props:any) => props.styleProp.hasError?props.theme.palette.danger :props.theme.palette.neutral.greys200};
border-radius: 8px;
justify-content: center;
${props => ({ ...props?.styleProp?.containerStyle as object })};
  `;
  